import {
  TextField,
  Typography,
} from '@mui/material';
import ButtonWithSpinner from '../../../../../components/buttons/ButtonWithSpinner';
import useSettingForm from './useSettingForm';
import './SettingTextFieldForm.scss';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  minLength: 1,
  subLabel: '',
};

const SettingTextFieldForm = (p) => {
  const {
    label,
    subLabel,
    attributeNameToSave,
    minLength,
  } = { ...defaultProps, ...filterUndefined(p) };
  const {
    loading,
    value,
    handleOnChange,
    handleOnClick,
  } = useSettingForm(label, attributeNameToSave);

  return (
    <div className='setting-text-field-form'>
      <Typography variant='subtitle1' className='label'>
        {label}
      </Typography>
      <div className='input-container'>
        <TextField
          value={value === null || value === undefined ? '' : value}
          variant='outlined'
          fullWidth
          onChange={handleOnChange}
          inputProps={{
            'aria-label': label,
          }}
        />
        <Typography variant='h6' className='sub-label'>
          {subLabel}
        </Typography>
      </div>
      <ButtonWithSpinner
        loading={loading}
        className='apply-button'
        label='Apply'
        disabled={value === null || value === undefined || value.length < minLength}
        onClick={() => handleOnClick({
          [attributeNameToSave]: value,
        })}
      />
    </div>
  );
};

export default SettingTextFieldForm;
